var map = {
	"./co2.jpg": 884,
	"./coal.jpg": 885,
	"./country-snapshot.jpg": 886,
	"./crude_oil.jpg": 887,
	"./gas.jpg": 888,
	"./homepage.jpg": 356,
	"./oil.jpg": 889,
	"./powerplant.jpg": 890,
	"./renewables.jpg": 891,
	"./total.jpg": 892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 883;